import { render } from "./RequiredProfileModal.vue?vue&type=template&id=6c626e0c&scoped=true&ts=true"
import script from "./RequiredProfileModal.vue?vue&type=script&lang=ts"
export * from "./RequiredProfileModal.vue?vue&type=script&lang=ts"

import "./RequiredProfileModal.vue?vue&type=style&index=0&id=6c626e0c&scoped=true&lang=css"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c626e0c"]])

export default __exports__